<template>
    <div v-if="isShow" class="loading">
        <div class="loading-main">Loading...</div>
    </div>
</template>

<script>
    export default {
        name: "loading",
        props:{
            isShow:{
                type:Boolean,
                default:false
            }
        }
    }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
    .loading
        position fixed
        left 0
        right 0
        top 0
        bottom 0
        background-color rgba(0,0,0,0.8)
        z-index 888
        .loading-main
            position absolute
            left 0
            top 0
            right 0
            bottom 0
            margin auto
            width 200px
            height 100px
            color #ffffff
            text-align center
            line-height 100px
            /*border 1px solid #0f0*/




</style>


// WEBPACK FOOTER //
// src/components/globalComp/loading.vue